<template>
  <div class="dialog">
    <el-dialog title="详情"
               :visible.sync="visible"
               :lock-scroll="true"
               width="600px"
               :before-close="handleClose">
      <el-form ref="formTool"
               :model="formTool"
               :inline="true"
               style="text-align: left"
               label-width="140px">
        <div class="goodList">
          <div class="img-div">
            <el-image class="l"
                      :src="formTool.image ? formTool.image : avater"
                      alt="" />
          </div>
          <div class="r">
            <div>
              <span class="txt-line-1 name">{{ formTool.name }}</span>
            </div>
            <div>
              <span class="rr txt-line-1">{{ formTool.specification }}</span>
            </div>
            <div>
              <span class="rr txt-line-1">{{ formTool.approvalNumber }}</span>
            </div>
            <div>
              <span class="rr txt-line-1">{{ formTool.factory }}</span>
            </div>
          </div>
        </div>

        <el-row class="reject-c"
                v-if="formTool.remark">
          <div class="title">
            驳回原因
          </div>
          <el-input v-model="formTool.remark"
                    type="textarea"
                    clearable
                    :disabled="true"
                    style="width:50%" />

        </el-row>

        <div class="left_topic mb20"
             style="margin-top: 10px;">推广费用设置</div>
        <el-row class="list">
          <el-form-item prop="salesUserRate"
                        label="推广费用比例"
                        :rules="{ required: true, message: '请填写推广费用比例', trigger: 'blur' }">
            <el-input v-model="formTool.salesUserRate"
                      placeholder="请输入"
                      clearable
                      size="small"
                      :disabled="isDisabled" />
          </el-form-item>
          % (输入范围5~50)

        </el-row>
        <el-row class="list">
          <el-form-item prop="platformServiceRate"
                        label="推广服务费比例">
            <el-input v-model="formTool.platformServiceRate"
                      disabled
                      clearable
                      size="small" />
          </el-form-item>
          %

        </el-row>

        <!-- <el-row class="list">
          <el-form-item prop="goodsScopeRate"
                        label="技术服务费比例">
            <el-input v-model="formTool.goodsScopeRate"
                      clearable
                      size="small"
                      disabled />
          </el-form-item>
          %
        </el-row> -->

        <div class="left_topic mb20"
             style="margin-top: 10px">试用期任务及合作期限</div>
        <el-row class="list">
          <el-form-item prop="probationDays"
                        label="试用期"
                        :rules="{ required: true, message: '请填写试用期', trigger: 'blur' }">
            <el-input v-model="formTool.probationDays"
                      placeholder="请输入"
                      clearable
                      size="small"
                      :disabled="isDisabled" />

          </el-form-item>
          天
        </el-row>

        <el-row class="list">
          <el-form-item prop="probationAmount"
                        label="试用任务要求"
                        :rules="{ required: true, message: '请填写试用任务要求', trigger: 'blur' }">
            <el-input v-model="formTool.probationAmount"
                      placeholder="请输入"
                      clearable
                      size="small"
                      :disabled="isDisabled" />
          </el-form-item>
          {{ formTool.goodsSkuUnit || '' }}
        </el-row>
        <el-row class="list">
          <el-form-item prop="cooperateDays"
                        label="合作期"
                        :rules="{ required: true, message: '请填写合作期', trigger: 'blur' }">
            <el-input v-model="formTool.cooperateDays"
                      placeholder="请输入"
                      clearable
                      size="small"
                      :disabled="isDisabled" />
          </el-form-item>
          天
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import avater from "/public/img/default.png";
import {
  externalInfo,
} from "@/api/externalSalesRule";
export default {
  components: {
  },
  props: {
  },
  computed: {
    visible () {
      return this.dialogShow
    }
  },
  data () {
    return {
      avater: avater,
      showForm: false, //是否展示表单
      dialogShow: false,
      isDisabled: true,
      info: {},
      formTool: {
        salesUserRate: '',
        probationDays: '',
        cooperateDays: '',
        probationAmount: '',
        salesUserAmount: '',
        platformServiceRate: '',
        goodsScopeRate: ''
      },
    }
  },
  mounted () {
  },
  methods: {
    init (id) {
      this.dialogShow = true;
      this.externalInfo(id)
    },

    handleClose () {
      this.dialogShow = false;
    },
    cancel () {
      this.dialogShow = false;
    },
    externalInfo (id) {
      externalInfo(id).then(res => {
        console.log(res)
        this.formTool = res;
        let newRes = Object.assign({},res);
        this.formTool.salesUserRate = (newRes.salesUserRate *100).toFixed(2);
        this.formTool.platformServiceRate = (newRes.platformServiceRate * newRes.salesUserRate * 100 ).toFixed(2);
        this.formTool.goodsScopeRate =( newRes.goodsScopeRate *100 ).toFixed(2); 
      })
    }
  }
}
</script>
<style lang="scss">
.btnBox {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.serach {
  margin-bottom: 10px;
}

.goods-content {
  max-height: 70vh;
  overflow-y: auto;
}

.goodList {
  display: flex;
  justify-content: space-around;

  &:nth-child(3n) {
    margin-right: 0px;
  }

  .img-div {
    height: 88px;
    width: 88px;
    margin: 0 10px;

    image {
      width: 100%;
      height: 100%;
    }
  }

  .l {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    object-fit: cover;
  }

  .r {
    width: 214px;
    display: flex;
    flex: 1;
    flex-direction: column;

    div {
      display: flex;
    }

    span {
      font-size: 13px;
      color: #333;
      //margin-top: 10px;
    }

    .name {
      text-align: left;
      font-size: 16px;
      font-weight: 600;
      color: var(--color-26);
    }

    .rr {
      text-align: left;
      color: var(--color-59);
      font-size: 14px;
    }
  }

  &:hover {
    //  border: 2px solid var(--main-color) !important;
  }
}

.reject-c {
  margin-top: 10px;

  .title {
    line-height: 30px;
  }
}

.list {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  line-height: 40px;
}
</style>